import "./index.sass";
import "../../main.css";
import { observer } from "mobx-react";
import StoreContext from "../../store/RootStore";
import { useEffect, useRef } from "react";
import LoginHandler from "../../functions/login";

function HOF() {
  const { AccountStore } = StoreContext();

  // Instance stable de LoginHandler
  const loginHandlerRef = useRef(null);
  if (loginHandlerRef.current === null) {
    loginHandlerRef.current = new LoginHandler();
  }
  const loginHandler = loginHandlerRef.current;

  useEffect(() => {
    if (AccountStore.accountAddress) {
      loginHandler.getZonesConfig();
      loginHandler.getWinsScope();
    }
  }, [AccountStore.accountAddress, loginHandler]);

  // Renvoie les 5 meilleurs comptes pour un terrain donné
  function filterAccountZoneWins(SelectedTerrain) {
    const zoneWins = AccountStore.winsScope || [];
    const Zconfig = AccountStore.Zconfig || [];

    const zoneNameById = new Map(Zconfig.map(z => [z.id, z.name]));

    const winsByUser = new Map();
    for (let i = 0; i < zoneWins.length; i++) {
      const userName = zoneWins[i].name;
      const balances = zoneWins[i].balances || [];
      for (let j = 0; j < balances.length; j++) {
        const zId = balances[j].zone;
        const zName = zoneNameById.get(zId);
        if (zName === SelectedTerrain) {
          const prev = winsByUser.get(userName) || 0;
          winsByUser.set(userName, prev + balances[j].wins);
        }
      }
    }

    const accounts = Array.from(winsByUser.entries())
      .map(([name, wins]) => ({ name, wins }))
      .sort((a, b) => b.wins - a.wins)
      .slice(0, 5);

    return { accounts };
  }

  function filterDivisions() {
    const allDivisions = (AccountStore.allDivisions || []).slice();
    allDivisions.sort((a, b) => b.power - a.power);
    return allDivisions.slice(0, 20);
  }

  return (
    <div className="parent">
      <div className="left50">
        <div id="topOfficer">
          <div className="topTitle">
            <span>TOP 5</span>
          </div>
          <div className="topDesc">
            <h2>Officers</h2>
            <span>(ranked by number of victories on objectives)</span>
          </div>
        </div>
        <div className="clearfix"></div>

        <div id="topArmed">
          <div className="arrow"></div>
          <div className="topTitle">
            <span>TOP 20</span>
          </div>
          <div className="topDesc">
            <h2>Armed forces</h2>
            <span>(Ranked by the strenght of the military divisions)</span>
          </div>
        </div>
        <div className="clearfix"></div>

        <div id="ArmedTable" className="tableHoF">
          <table>
            <tbody>
              {filterDivisions().map((asset, index) => (
                <tr key={`armed-${asset.owner}-${asset.divID}-${index}`}>
                  <td>
                    <span>{index + 1}</span>
                  </td>
                  <td>
                    <span>{asset.owner}</span>
                  </td>
                  <td>
                    <span>ID: {asset.divID}</span>
                  </td>
                  <td>{parseFloat(asset.power / 10000).toFixed(1)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="right50">
        <div id="bunkerHoF" className="zoneHoF">
          <div className="leftZoneHoF">
            <img src={require("../../assets/dov/hof/bunker.png")} alt="" />
          </div>
          <div className="rightZoneHoF tableHoF">
            <table>
              <tbody>
                {filterAccountZoneWins("bunker").accounts.map((asset, index) => (
                  <tr key={`bunker-${asset.name}-${index}`}>
                    <td>
                      <span>{index + 1}</span>
                    </td>
                    <td>
                      <span>{asset.name}</span>
                    </td>
                    <td>{asset.wins} Victories</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="clearfix" style={{ padding: "5px" }}></div>

        <div id="campHoF" className="zoneHoF">
          <div className="leftZoneHoF">
            <img src={require("../../assets/dov/hof/camp.png")} alt="" />
          </div>
          <div className="rightZoneHoF tableHoF">
            <table>
              <tbody>
                {filterAccountZoneWins("camp").accounts.map((asset, index) => (
                  <tr key={`camp-${asset.name}-${index}`}>
                    <td>
                      <span>{index + 1}</span>
                    </td>
                    <td>
                      <span>{asset.name}</span>
                    </td>
                    <td>{asset.wins} Victories</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="clearfix" style={{ padding: "5px" }}></div>

        <div id="radarHoF" className="zoneHoF">
          <div className="leftZoneHoF">
            <img src={require("../../assets/dov/hof/radar.png")} alt="" />
          </div>
          <div className="rightZoneHoF tableHoF">
            <table>
              <tbody>
                {filterAccountZoneWins("radar").accounts.map((asset, index) => (
                  <tr key={`radar-${asset.name}-${index}`}>
                    <td>
                      <span>{index + 1}</span>
                    </td>
                    <td>
                      <span>{asset.name}</span>
                    </td>
                    <td>{asset.wins} Victories</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="clearfix" style={{ padding: "5px" }}></div>

        <div id="hqHoF" className="zoneHoF">
          <div className="leftZoneHoF">
            <img src={require("../../assets/dov/hof/hq.png")} alt="" />
          </div>
          <div className="rightZoneHoF tableHoF">
            <table>
              <tbody>
                {filterAccountZoneWins("hq").accounts.map((asset, index) => (
                  <tr key={`hq-${asset.name}-${index}`}>
                    <td>
                      <span>{index + 1}</span>
                    </td>
                    <td>
                      <span>{asset.name}</span>
                    </td>
                    <td>{asset.wins} Victories</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="clearfix" style={{ padding: "5px" }}></div>

        <div id="bridgeHoF" className="zoneHoF">
          <div className="leftZoneHoF">
            <img src={require("../../assets/dov/hof/bridge.png")} alt="" />
          </div>
          <div className="rightZoneHoF tableHoF">
            <table>
              <tbody>
                {filterAccountZoneWins("bridge").accounts.map((asset, index) => (
                  <tr key={`bridge-${asset.name}-${index}`}>
                    <td>
                      <span>{index + 1}</span>
                    </td>
                    <td>
                      <span>{asset.name}</span>
                    </td>
                    <td>{asset.wins} Victories</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default observer(HOF);
